import type { HydraCollection } from "@verbleif/lib/src/composables/Api/Type/hydra.interface";
import type { PropertyTaskStateHydraItem } from "@verbleif/lib/src/composables/Api/Type/Property/property.interface";
import type { PropertyReservationStatesHydraItem } from "@verbleif/lib/src/composables/Api/Type/PropertyReservationMultiState/propertyReservationState.interface";
import { api } from "@verbleif/shared/src/composables/Api/api";

export async function fetchPropertyReservationStates(
  params: URLSearchParams,
): Promise<HydraCollection<PropertyReservationStatesHydraItem>> {
  const { data } = await api.get<HydraCollection<PropertyReservationStatesHydraItem>>("/api/property_reservation_states", {
    params,
  });
  return data;
}

export async function fetchPropertyTaskStates(
  params: URLSearchParams,
): Promise<HydraCollection<PropertyTaskStateHydraItem>> {
  const { data } = await api.get<HydraCollection<PropertyTaskStateHydraItem>>("/api/property_task_states", {
    params,
  });
  return data;
}
